/** Запас ширины последнего столбца (Y) под вертикальный скролл TableContainer. */
const COMPOSITION_MODULES_TAB_TABLE_SCROLLBAR_ALLOWANCE = 17;

/** Общая минимальная ширина обеих таблиц вкладки «Модули». */
export const COMPOSITION_MODULES_TAB_TABLE_WIDTH = 1370;

const COMPOSITION_MODULES_TABLE_COL_WIDTHS_WITHOUT_NAME = {
    priority: 130,
    width: 104,
    height: 104,
    depth: 112,
    sideBaseModule: 168,
    heightLocation: 112,
    coordinateXPoint: 60,
    coordinateYPoint: 56 + COMPOSITION_MODULES_TAB_TABLE_SCROLLBAR_ALLOWANCE,
};

const COMPOSITION_MODULES_FIXED_COL_WIDTH = Object.values(
    COMPOSITION_MODULES_TABLE_COL_WIDTHS_WITHOUT_NAME,
).reduce((sum, w) => sum + w, 0);

/** Ширины столбцов первой таблицы; «Наименование» — остаток до ширины таблицы. */
export const COMPOSITION_MODULES_TABLE_COL_WIDTHS = {
    ...COMPOSITION_MODULES_TABLE_COL_WIDTHS_WITHOUT_NAME,
    name: COMPOSITION_MODULES_TAB_TABLE_WIDTH - COMPOSITION_MODULES_FIXED_COL_WIDTH,
};

export const COMPOSITION_MODULES_TAB_TABLE_MIN_WIDTH = COMPOSITION_MODULES_TAB_TABLE_WIDTH;

/** Одна обёртка для обеих таблиц вкладки «Модули». */
export const compositionModulesTabTableScrollSx = {
    overflow: 'auto',
    maxWidth: 'calc(100vw - 410px)',
    width: '100%',
    boxSizing: 'border-box',
};
